// extracted by mini-css-extract-plugin
export default {"linkbuttona":"styles__linkbuttona___aOF6R","is-inactive":"styles__is-inactive___WZ1OK"};